import React from "react";
import ModalV2 from "../modalV2";
import { SUCCESS_IMG } from "../../../assets";
import ButtonV2 from "../buttonV2";

function SuccessModal({
  open,
  close,
  action,
  message,
  message2,
}: {
  open: boolean;
  close: () => void;
  action: () => void;
  message: string;
  message2: string;
}) {
  return (
    <ModalV2
      isOpen={open}
      isClose={close}
      maxWidth={"w-[400px]"}
      edges={"rounded-xl"}
    >
      <div className="w-full p-5">
        <img src={SUCCESS_IMG} className="w-full h-[160px]" alt="" />
        <div className="flex flex-col gap-y-1">
          <span className="text-[#303237] font-medium text-xl">{message}</span>
          <span className="text-sm font-medium text-[#2A2E34]">{message2}</span>
        </div>

        <ButtonV2
          title={"Done"}
          btnStyle={"w-full bg-globalGold rounded-xl p-3 mt-4"}
          textStyle={"text-white font-normal "}
          handleClick={action}
        />
      </div>
    </ModalV2>
  );
}

export default SuccessModal;
